import { AutocompleteWithLabel } from '@adotel/components'
import { Button, ButtonBase, Fade, Typography } from '@material-ui/core'
import { SvgIcon } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import moment from 'moment-jalaali'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { ReactComponent as MyIconSvg } from '../../../../assets/images/Group.svg'
import { CounterWithLabel } from '../../../../components/CounterWithLabel'
import { DateRangePicker } from '../../../../components/DatePicker/DateRangePicker'
import {
  addDaysToDate,
  formatShortDateWithWeekDay
} from '../../../../helpers/date'
import { persianRegex } from '../../../../helpers/regex'
import { getCurrenciesAvailable } from '../../../../helpers/userData'
import { getTranslate, lang } from '../../../../localization'
import { LocalizedLink } from '../../../../routes/localizedRoutes'
import calculateRangeOfDays from '../../CalculateRangeOfDays'
import convertDate from '../../ConvertDate'
import SearchWidgetArrivalDate from '../../SearchWidgetArrivalDate'
import SearchWidgetDepartureDate from '../../SearchWidgetDepartureDate'
import SearchWidgetGuests from '../../SearchWidgetGuests'
import SearchWidgetSearchInput from '../../SearchWidgetSearchInput'
import { SearchWidgetProps } from '../SearchWidgetProps'
import useStyles from '../styles/SearchWidget.styles'

const SearchWidgetDesktopInterface: React.FC<SearchWidgetProps> = ({
  selectRangeModalIsOpen,
  setSelectRangeModalIsOpen,
  selectNumberOfGuestsModalIsOpen,
  setSelectNumberOfGuestsModalIsOpen,
  dateObject,
  setdateObject,
  guestsNumber,
  setguestsNumber,
  datePickerRef,
  effectFunction,
  guestInfoRef,
  type,
  options,
  readMode,
  setreadMode,
  searchAvailabilityInput,
  setSearchAvailabilityInput,
  loadingForAccommodation
}) => {
  const classes = useStyles()
  const params = useParams<{ channelId: string; code: string; name: string }>()
  const isPersian = persianRegex.test(params.name)

  useEffect(
    () => effectFunction(),
    [
      datePickerRef,
      selectRangeModalIsOpen,
      selectNumberOfGuestsModalIsOpen,
      guestInfoRef
    ]
  )
  const nowDate = moment().format('YYYY-MM-DD')

  const tomorrow = addDaysToDate(nowDate, 1)
  const range =
    dateObject && dateObject.gregorianStartDate && dateObject.gregorianEndDate
      ? calculateRangeOfDays(
          dateObject && dateObject.gregorianStartDate
            ? dateObject.gregorianStartDate
            : nowDate,

          dateObject && dateObject.gregorianEndDate
            ? dateObject.gregorianEndDate
            : tomorrow
        )
      : 1
  const [autoCompleteLabelForCurrency, setautoCompleteLabelForCurrency] =
    useState<any>({
      value: searchAvailabilityInput.currency,
      label:
        lang === 'fa'
          ? getTranslate(searchAvailabilityInput.currency || '')
          : searchAvailabilityInput.currency
    })

  const selectedDestination = options.find((item) => {
    if (searchAvailabilityInput && searchAvailabilityInput.cityID) {
      return item.cityID === searchAvailabilityInput.cityID
    } else if (
      searchAvailabilityInput &&
      searchAvailabilityInput.propertyCode
    ) {
      return item.destinationCode === searchAvailabilityInput.propertyCode
    }
  })
  if (readMode) {
    return (
      <div className={classes.readMode}>
        <div className={classes.left}>
          <div className={classes.searchContainer}>
            <SearchIcon className={classes.icon} />
          </div>
          <div className={classes.nameContainer}>
            <Typography variant="h4" className={classes.title}>
              {selectedDestination?.destinationName}
            </Typography>
            <div className={classes.individual}>
              <SvgIcon
                component={MyIconSvg}
                fontSize="small"
                color="primary"
                className={classes.svg}
              />
              <Typography variant="h4" className={classes.smallTitle}>
                {`${searchAvailabilityInput.guestsAges.length} ${getTranslate(
                  'Travelers'
                )}${getTranslate(',')} 1 ${getTranslate('Room')} ${getTranslate(
                  'and'
                )} ${range} ${getTranslate('Nights')}`}
              </Typography>
            </div>
          </div>
        </div>
        <div className={classes.middle}>
          <div className={classes.date}>
            <Typography variant="h4" className={classes.title2}>
              {`${
                searchAvailabilityInput.arrival &&
                formatShortDateWithWeekDay(
                  searchAvailabilityInput.arrival,
                  lang
                )
              }`}
            </Typography>
          </div>
          <div className={classes.date}>
            <Typography variant="h4" className={classes.title2}>
              {`${
                searchAvailabilityInput.departure &&
                formatShortDateWithWeekDay(
                  searchAvailabilityInput.departure,
                  lang
                )
              }`}
            </Typography>
          </div>
        </div>
        <div className={classes.right}>
          <Button
            color="primary"
            variant="contained"
            className={classes.btn}
            onClick={() => setreadMode(false)}>
            <Typography variant="h4" className={classes.btnText}>
              {getTranslate('Update ')}
            </Typography>
          </Button>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className={classes.searchMode}>
        <div className={classes.destinationContainer}>
          <SearchWidgetSearchInput
            options={options}
            searchAvailabilityInput={searchAvailabilityInput}
            setSearchAvailabilityInput={setSearchAvailabilityInput}
            loadingForAccommodation={loadingForAccommodation}
          />
        </div>
        <div className={classes.separator} />
        <div
          className={classes.arrivalContainer}
          onClick={() => {
            setSelectRangeModalIsOpen(true)
          }}>
          <SearchWidgetArrivalDate
            data={convertDate(
              dateObject && dateObject.gregorianStartDate
                ? dateObject.gregorianStartDate
                : nowDate
            )}
          />
          {selectRangeModalIsOpen && (
            <Fade in={selectRangeModalIsOpen} timeout={500}>
              <div className={classes.dateModal} ref={datePickerRef}>
                <div className={classes.nightContainer}>
                  <Typography variant="h4" className={classes.red}>
                    {range}
                  </Typography>
                  <Typography
                    variant="h4"
                    className={classes.text}>{`${getTranslate(
                    'Nights'
                  )}`}</Typography>
                  <div></div>
                </div>
                <DateRangePicker
                  onChange={(date) => {
                    setdateObject(date)
                  }}
                  dateObject={dateObject}
                  type={type}
                  onDoneClicked={(event) => {
                    event.stopPropagation()
                    setSelectRangeModalIsOpen(false)
                  }}
                  endDateCanBeSelectAsStartDate={false}
                />
              </div>
            </Fade>
          )}
        </div>
        <div className={classes.separator} />
        <div
          className={classes.departueContainer}
          role="presentation"
          onClick={() => {
            setSelectRangeModalIsOpen(true)
          }}>
          <SearchWidgetDepartureDate
            data={convertDate(
              dateObject && dateObject.gregorianEndDate
                ? dateObject.gregorianEndDate
                : tomorrow
            )}
          />
        </div>
        <div className={classes.separator} />
        <div
          className={classes.roomAndGuestContainer}
          onClick={() => setSelectNumberOfGuestsModalIsOpen(true)}>
          <SearchWidgetGuests guestsNumber={guestsNumber} />
          {selectNumberOfGuestsModalIsOpen && (
            <Fade in={selectNumberOfGuestsModalIsOpen} timeout={500}>
              <div className={classes.guestModal} ref={guestInfoRef}>
                <CounterWithLabel
                  label={getTranslate('Adults')}
                  value={guestsNumber}
                  setValue={setguestsNumber}
                  min={1}
                />
              </div>
            </Fade>
          )}
        </div>
        <div className={classes.currencyContainer}>
          <div className={classes.currencyRoot}>
            <AutocompleteWithLabel
              disableClearable
              fullWidth
              noHelperText
              value={autoCompleteLabelForCurrency}
              classes={{
                input: classes.currencyLabelColor,
                inputRoot: classes.autocompleteBorder,
                endAdornment: classes.adorment
              }}
              onChange={(_, v: any) => {
                if (v) {
                  setautoCompleteLabelForCurrency({
                    value: v.value,
                    label: v.label
                  })
                  setSearchAvailabilityInput?.((prev) => ({
                    ...prev,
                    currency: v.value
                  }))
                }
              }}
              inputSize="small"
              options={getCurrenciesAvailable().map((currency) => ({
                label:
                  lang === 'fa'
                    ? getTranslate(currency as string)
                    : (currency as string),
                value: currency as string
              }))}
            />
          </div>
        </div>
        <div className={classes.searchButtonContianer}>
          <ButtonBase
            component={LocalizedLink}
            to={`/book/${params.channelId}/${params.code}/${params.name}/${
              searchAvailabilityInput.cityID ? 'city' : 'hotel'
            }/?filter=${encodeURIComponent(
              JSON.stringify(searchAvailabilityInput)
            )}`}
            className={classes.buttonBase}
            disabled={
              !(
                searchAvailabilityInput.propertyCode ||
                !!searchAvailabilityInput.cityID
              )
            }>
            <Button
              variant="contained"
              color="primary"
              disabled={
                !!!searchAvailabilityInput.propertyCode &&
                !!!searchAvailabilityInput.cityID
              }
              fullWidth
              className={classes.searchButton}
              onClick={() => setreadMode(!readMode)}
              endIcon={<SearchIcon className={classes.searchIcon} />}>
              <Typography className={classes.btnText}>
                {getTranslate('Search')}
              </Typography>
            </Button>
          </ButtonBase>
        </div>
      </div>
      <div className={classes.channelName}>
        <Typography style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
          {params.name}
        </Typography>
      </div>
    </>
  )
}
export default SearchWidgetDesktopInterface
